module.exports = require("core-js/library/fn/object/get-own-property-symbols");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/get-own-property-symbols.js
// module id = 65
// module chunks = 35783957827783 114276838955818 162898551421021